module.exports = __webpack_public_path__ + "static/img/mont1.d5bdcb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mont1.png
// module id = 5tQy
// module chunks = 0